import type {
  BackendErrorResponse,
  ParsedErrorDetail,
} from '../@types/backend-error-response';

function getDetailFromObject(errorObject: unknown) {
  if (typeof errorObject === 'object' && errorObject !== null) {
    if ('response' in errorObject) {
      const backendErrorResponse = errorObject as BackendErrorResponse;

      return backendErrorResponse?.response?.error?.showErrorToUi
        ? backendErrorResponse?.response?.error?.detail
        : undefined;
    }
    if (
      'detail' in errorObject &&
      'showErrorToUi' in errorObject &&
      errorObject.showErrorToUi
    ) {
      return (errorObject as ParsedErrorDetail)?.detail;
    }
  }
}

export async function resolveBackendError(error: unknown) {
  let errorMessage: string | undefined;

  if (error instanceof Response) {
    try {
      const unknownError = (await error.json()) as unknown;
      errorMessage = getDetailFromObject(unknownError);
    } catch (parseError) {
      console.error('Error parsing the error message:', parseError);
    }
  }

  return errorMessage ?? getDetailFromObject(error);
}
